















import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import SoftwareList from "@/components/SoftwareList.vue";
import { AccountInfo } from '@azure/msal-browser';

@Component({
	components: {
		SoftwareList
	}
})
export default class Software extends Vue {

}
